const IbmpNasalThemeVariables: Record<string, any> = {
  // Informações sobre o teste
  manufacturer: 'Ibmp',
  pageTitle: 'WebApp - Autoteste COVID Ag IBMP Nasal',
  testName: 'Autoteste COVID Ag IBMP Nasal',
  backgroundDisableButton: '#B2DDD1',
  backgroundBase: '#159B77',
  backgroundBaseFilter:
    "invert(58%) sepia(92%) saturate(299%) hue-rotate(129deg) brightness(86%) contrast(91%)",
  backgroundBaseGradient: "#f9b70f",
  backgroundDaxQRCode: "linear-gradient(to right, #159B77, #f9b70f, #159B77)",
  backgroundLoaderResult:
    "linear-gradient(196.38deg, #159B77 0%, #075153 40.5%, #159B77 100%)",
  backgroundLoaderAnimationStepA:
    "linear-gradient(196.38deg, #159B77 0%, #075153 73.35%, #159B77 100%)",
  backgroundLoaderAnimationStepB:
    "linear-gradient(196.38deg, #159B77 0%, #075153 40.5%, #159B77 100%)",
  backgroundLoaderAnimationStepC:
    "linear-gradient(196.38deg, #159B77 0%, #075153 17.39%, #159B77 100%)",
  backgroundLoaderBar:
    "linear-gradient(90deg, rgba(80, 165, 81, 0) 0%, #50A551 45.16%, rgba(80, 165, 81, 0) 100%)",
  backgroundShareResult: "#F7FCFA",
  backgroundShareScreen: "#F7FCFA",
  ResultShareModal: "#159B77",
  ResultShareModalTitle: "#ffffff",
  backgrounBaseLinear:
    "linear-gradient(196.38deg, #159B77 0%, #075153 37.75%, #159B77 100%)",
  // Bolinhas escuras dos passos
  backgroundStrongBase: "#BAB7B5",

  backgroundExportButton: "#159B77",
  urlPathLoaderFile: "ibmp/nasal/ibmp-nasal-preparing-results.png",
  urlPathLogoFile: "ibmp/nasal/logo_ibmp_capa.png",
  urlPathLogoFileWhiteHeader: "ibmp/nasal/logo_ibmp_header.png",
  urlPathLogoFileWhite: "ibmp/nasal/logo_ibmp_white.png",
  urlPathLogoResult: "ibmp/nasal/logo_ibmp_white.png",
  urlPathLogoFileCrx: "clinicarx-logo-green.svg",
  urlFavicon: "ibmp/nasal/favicon.png",
  logoWidth: "156px",
  logoHeight: "80px",
  logoWidthWhite: "90px",
  logoHeightWhite: "54px",
  logoWidthResult: "90px",
  logoHeightResult: "54px",
  logoWhiteTopMargin: "12px",
  logoWidthWhiteDask: "243px",
  logoHeightWhiteDask: "80px",
  logoViewResultCardWidth: "104px",
  logoViewResultCardHeight: "54px",
  urlPathTestImage: "ibmp/nasal/capa.png",
  urlPathDocumentIcon: "eco/card-result.png",
  urlVideoGuidelines: "https://www.youtube.com/embed/nkZy-8I7S6I",
  urlPathQRCode: "ibmp/nasal/qr_code_ibmp.png",
  socialShareInfo:
    "Acabei de gerar o cartão de resultado do meu Autoteste COVID Ag da IBMP Nasal. Fazer o autoteste é cuidar de você e de quem você ama.",
  totalSteps: 8,
  testStepOneContents: {
    title: "Colete a amostra:",
    steps:
      "<ol> <li>Assoe o nariz e higienize as mãos;</li><li>Abra a embalagem do cotonete (swab);</li><li>Insira a ponta com algodão aproximadamente 1,5cm na narina. Gire 5 vezes passando no interior da narina. Repita o procedimento na outra narina com o mesmo swab.</li> <ol>",
    image: "ibmp/nasal/ibmp_nasal_passo_1.gif",
    warningActive: true,
    warningText:
      "Não toque com a sua mão na ponta de algodão do cotonete (swab).",
  },
  testStepTwoContents: {
    title: "Prepare sua amostra para o teste:",
    steps:
      "<ol> <li>Pegue o tubo com o líquido diluente;</li><li>Fure o lacre com a ponta do conta-gotas;</li><li>Insira o swab com a amostra coletada;</li><li>Gire 5 vezes e depois remova, apertando o frasco para pressionar a ponta do swab.</li><li>Feche com a tampa conta-gotas, agite delicadamente e aguarde 1 minuto.</li> <ol>",
    image: "ibmp/nasal/ibmp_nasal_passo_2.gif",
    warningActive: true,
    warningText:
      "Caso ocorra contato da solução com sua pele ou olhos, lave imediatamente com água.",
  },
  testStepThreeContents: {
    title: "Pingue as gotas no dispositivo:",
    steps:
      "<ol> <li>Retire o dispositivo do teste da embalagem;</li><li>Remova a cobertura de proteção do conta-gotas e descarte duas gotas;</li><li>Mantenha o tubo na vertical e aperte no local indicado na etiqueta;</li><li>Pingue 3 gotas na cavidade menor do teste.</li> <ol>",
    image: "ibmp/nasal/ibmp_nasal_passo_3.gif",
    warningActive: true,
    warningText:
      "Atenção com a contagem das gotas. Não aplique mais de 3 gotas.",
    timerInMinutes: 15,
  },
  testStepEightContents: {
    title: "Informe os demais dados pessoais",
    warningText:
      "Utilizamos o CPF para reforçar sua identidade no cartão de resultado compartilhável do teste e para seu cadastro com a Clinicarx.",
  },
  testStepFourContents: {
    title: "Informe o resultado do autoteste",
    warningText:
      'A intensidade da cor das linhas no dispositivo podem variar e mesmo os tons mais claros devem ser considerados. <span id="modalLink" style="color: #006ba6; text-decoration: underline;"> Clique aqui se o resultado não mostra a linha “C”.</span>',
  },
  testStepFiveContents: {
    title: "Tire uma foto do resultado do autoteste",
    warningText:
      '<span id="modalLink" style="color: #006ba6; text-decoration: underline;">Ver instruções e exemplo de como tirar a foto.</span>',
  },
  // Result image variables
  urlNegativeWithoutSymptomsImage:
    "ibmp/nasal/ibmp-nasal-negative-without-symptons.png",
  heightNegativeWithoutSymptomsImage: "173px",
  widthNegativeWithoutSymptomsImage: "173px",
  urlNegativeWithSymptomsImage:
    "ibmp/nasal/ibmp-nasal-negative-with-symptons.png",
  heightNegativeWithSymptomsImage: "124px",
  widthNegativeWithSymptomsImage: "122px",
  urlPositiveWithoutSymptomsImage:
    "ibmp/nasal/ibmp-nasal-positive-without-symptons.png",
  heightPositiveWithoutSymptomsImage: "121px",
  widthPositiveWithoutSymptomsImage: "173px",
  urlPositiveWithSymptomsImage:
    "ibmp/nasal/ibmp-nasal-positive-with-symptons.png",
  heightPositiveWithSymptomsImage: "124px",
  widthPositiveWithSymptomsImage: "150px",
};

export { IbmpNasalThemeVariables };
